// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router/index";
import store from './store'
import { Button } from "iview";
import "hover.css";
import "./theme.less";
import { Popup, Swipe, SwipeItem } from "vant";
import "vant/lib/index.less";
Vue.config.productionTip = false;
((n, e) => {
  var t = n.documentElement,
    i = "orientationchange" in window ? "orientationchange" : "resize",
    o = function () {
      var n = t.clientWidth;
      n &&
        (n >= 750
          ? (t.style.fontSize = "100px")
          : (t.style.fontSize = 100 * (n / 750) + "px"));
    };
  n.addEventListener &&
    (e.addEventListener(i, o, !1),
      n.addEventListener("DOMContentLoaded", o, !1));
})(document, window);
Vue.use(Popup)
  .use(Button)
  .use(Swipe)
  .use(SwipeItem);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  }
});



// WEBPACK FOOTER //
// ./src/main.js